import driftrootLagoon02 from './driftroot_lagoon_02.json'
import meadow01 from './meadow_01.json'
import myTrack01 from './my_track_01.json'
import skyMeadow01 from './sky_meadow_01.json'

/** One bundled track file; `file` is its name without `.json` and must equal its `id`. */
export interface TrackFileEntry {
  readonly file: string
  readonly json: unknown
}

/** Every bundled track. Static imports so bundlers include them; add new tracks here. */
export const TRACK_FILES: readonly TrackFileEntry[] = [
  { file: 'meadow_01', json: meadow01 },
  { file: 'sky_meadow_01', json: skyMeadow01 },
  { file: 'driftroot_lagoon_02', json: driftrootLagoon02 },
  { file: 'my_track_01', json: myTrack01 },
]
